import { ParamsBuilder } from "../types";
import { RowState } from "../types";

export class DropdownBuilder implements ParamsBuilder {
  build(row: RowState): object {
    switch (row.operator) {
      case "is":
        return { [row.fieldName]: row.value };
      case "isNot":
        return { [row.fieldName]: { not: row.value } };
      default:
        return {};
    }
  }
}
